import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import SubtitleSemiBold from 'components/Typography/SubtitleSemiBold';
import { selectTokenUserName } from 'redux/reducers/authReducer';
import Button from 'components/DesignSystem/Button';
import BrandLogo from 'components/BrandLogo';
import ThemeSwitcher from 'components/ThemeSwitcher';
import logout from 'utils/logout';

import './index.scss';

export default function Header() {
  const navigate = useNavigate();
  const userName = useSelector(selectTokenUserName);

  const onLogout = () => {
    logout(navigate, { title: '', message: 'Logout realizado com sucesso.', variant: 'success' });
  };

  return (
    <div className="home-header w-100 d-flex justify-content-between">
      <div className="mx-4">
        <Link to="/home">
          <BrandLogo alt="Header logo" className="header-logo" />
        </Link>
      </div>
      <div className="mx-4 gap-3 d-flex flex-row align-items-center">
        <SubtitleSemiBold>
          Bem-vindo de volta,
          {' '}
          <b>{ userName }</b>
        </SubtitleSemiBold>
        <ThemeSwitcher />
        <Button
          onClick={onLogout}
          type="tertiary"
          className="header-logout-button"
        >
          Sair
        </Button>
      </div>
    </div>
  );
}
